import { cn } from '@massilia/ui'
import { CheckIcon, CopyIcon, type LucideIcon } from 'lucide-react'
import { useState } from 'react'

interface CopiableContactFieldProps {
  fieldClassName?: string
  iconClassName?: string
  labelClassName?: string
  icon: LucideIcon
  label: string
  value: string
}

export function CopiableContactField({
  fieldClassName,
  iconClassName,
  labelClassName,
  icon: Icon,
  label,
  value,
}: CopiableContactFieldProps) {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    await navigator.clipboard.writeText(value)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="flex w-full flex-col gap-2">
      <p className={cn('text-gray-light-700 text-sm font-semibold', labelClassName)}>{label}</p>
      <div
        className={cn(
          'border-gray-light-300 flex w-full items-center gap-2 rounded-lg border bg-white p-3 shadow',
          fieldClassName
        )}
      >
        <Icon className={cn('text-gray-light-500 h-4 w-4 shrink-0', iconClassName)} />
        <p className="text-gray-light-900 flex flex-1 text-sm font-medium break-words select-all">
          {value}
        </p>
        <button
          className="relative h-4 w-4 shrink-0 cursor-pointer"
          onClick={handleCopy}
          title="Copier"
          type="button"
        >
          <CopyIcon
            className={cn(
              'absolute inset-0 h-4 w-4 text-brand-500 transition-all duration-200 hover:text-brand-700',
              copied ? 'scale-0 opacity-0' : 'scale-100 opacity-100'
            )}
          />
          <CheckIcon
            className={cn(
              'absolute inset-0 h-4 w-4 text-success transition-all duration-200',
              copied ? 'scale-100 opacity-100' : 'scale-0 opacity-0'
            )}
          />
        </button>
      </div>
    </div>
  )
}
